let componentsData: any;

try {
  componentsData = require('../../../../dist/components_json.json');
} catch (error) {
  console.warn('components_json.json non trouvé. Utilisation de valeurs par défaut.');
  componentsData = {};
}

import { Meta, StoryFn } from '@storybook/web-components';
import { withComponentControls, toKebabCase } from '@utils/utils';

const elementTag = 'spw-loading';

const argTypes = withComponentControls(componentsData, { tag: elementTag });

const meta: Meta = {
  title: 'Composants/Chargement (loader)',
  component: elementTag,
  argTypes,
  tags: ['autodocs'],
  parameters: {
    docs: {
      description: {
        component: `
Indique que le contenu ou une action est en cours de chargement.

[<spw-link>Consulter la documentation</spw-link>](https://zeroheight.com/2310c7a1e/p/957e2a-chargement-loader)
        `,
      },
    },
  },
};

export default meta;

function htmlContent(slot) {
  return /* HTML */ `${slot}`;
}

const Template: StoryFn = args => {
  const element = document.createElement(elementTag);
  const hasSlot = false;
  const slottedLabel = 'label';

  Object.entries(args).forEach(([key, val]) => {
    if (key.startsWith('on')) {
      element.addEventListener(key.substring(2).toLowerCase(), val);
    } else {
      if (key !== slottedLabel) {
        element.setAttribute(toKebabCase(key), val as string);
      }
    }
  });

  if (hasSlot) {
    element.innerHTML = htmlContent(args[slottedLabel]);
  }

  return element;
};

export const Default = Template.bind({});
export const WithoutText = Template.bind({});
Default.args = {};
WithoutText.args = {
  text: '',
};
